// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"338":"aadea2705f872547","594":"6867f0beb176e4d4"}[chunkId] + ".js";
};